const accessTokenName = "admin-accessToken";

export const getAccessToken = () => {
    return localStorage.getItem(accessTokenName);
};

export const isAuthenticated = () => {
    return getAccessToken() !== null;
};
